import { AfterContentInit, Component, ViewChild, inject } from '@angular/core';
import { WebcamComponent, WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subject } from 'rxjs';
import { ToastService } from 'src/app/core/services/toast/toast.service';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.css']
})
export class CameraComponent implements AfterContentInit {
  private static readonly CAMERA_CONFIRM_KEY = 'camera-error-confirm';
  @ViewChild('webcam') webcam: WebcamComponent;
  deviceId: string;
  errors: WebcamInitError[] = [];
  optionsMedia: MediaStreamConstraints = { audio: false, video: true };
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  // latest snapshot 
  public webcamImage: WebcamImage = null;
  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  msg: ToastService = inject(ToastService);
  ref: DynamicDialogRef = inject(DynamicDialogRef);
  track: any;
  disabledCancel: boolean = false;
  disabledSnapshot: boolean = true;


  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  get videoOptions(): MediaTrackConstraints {
    return { facingMode: { ideal: 'environment' }, deviceId: { exact: this.deviceId }, width: { min: 1024, ideal: 1280, max: 1920 }, height: { min: 576, ideal: 720, max: 1080 } }
  }

  constructor() { }

  public async ngAfterContentInit() {
    // let devices = await navigator.mediaDevices.enumerateDevices();
    // this.msgExitCamara(String(devices.filter(d => d.kind === 'videoinput')[0].label), String(devices.filter(d => d.kind === 'videoinput').length));

    await navigator.mediaDevices.getUserMedia(this.optionsMedia).then((stream) => {
      if (stream) {
        stream.getTracks().map((track) => track.stop());
      }
    }, error => {
      this.handleInitError(error);
    });

    WebcamUtil.getAvailableVideoInputs().then(
      (mediaDevices: MediaDeviceInfo[]) => {
        if (mediaDevices) {
          this.disabledCancel = true;
          mediaDevices.length > 1 ?
            this.deviceId = mediaDevices.find(md => md.label.includes('0, facing back')).deviceId
            :
            this.deviceId = mediaDevices[0].deviceId;
          this.nextWebcam.next(this.deviceId);
          setTimeout(() => {
            this.disabledCancel = false;
            this.disabledSnapshot = false;
          }, 1500);
        }
      }, error => {
        this.handleInitError(error);
      }
    );
  }


  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public handleInitError(error: any): void {
    this.errors.push(error);
    console.log(JSON.stringify(error));
    if (error.mediaStreamError) {

      if (error.mediaStreamError.name === "NotAllowedError" || error.mediaStreamError.name === "NotFoundError ") {
        this.msgExitCamara("Permisos de cámara denegados", "Ha ocurrido un error al acceder a la cámara, por favor, revisa los permisos de la aplicación.");
        return;
      }
      if (error.mediaStreamError.name === "OverconstrainedError") {
        this.msgExitCamara("Error al cargar la cámara", "Puede ser que al cámara esté en uso en otra aplicación, por favor cierra las otras aplicaciones para acceder a la cámara.");
        return;
      }
      this.msgExitCamara("Algo ha fallado en la cámara", "Por favor inténtalo más tarde.");
      return;
    }
    this.msgExitCamara("Algo ha fallado en la cámara", "Ha ocurrido un error al acceder a la cámara");
  }

  private msgExitCamara(header: string, message: string) {
    this.msg.showConfirmation({
      key: CameraComponent.CAMERA_CONFIRM_KEY,
      icon: "pi pi-exclamation-triangle",
      header: header,
      message: message,
      acceptLabel: "Aceptar",
      accept: () => this.onCloseCamera(),
      rejectVisible: false
    });
  }

  private onCloseCamera(data?: string) {
    this.ref.close(data);
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
  }

  saveData() {
    this.onCloseCamera(this.webcamImage.imageAsBase64);
  }

  resetCamera() {
    this.webcamImage = null;
  }

  cancel() {
    this.onCloseCamera()
  }

  public async ngOnDestroy() {
    this.trigger.complete();
    const stream = await navigator.mediaDevices.getUserMedia(this.optionsMedia);  //si no hay permisos también va a entrar en error aquí
    if (stream) {
      stream.getTracks().map((track) => track.stop());
    }
  }
}